(function ($) {
	class BrandLogos {
		constructor() {
			this.initSelectors();
			this.bindEvents();
			this.visibleCount = 6; // Ako vratimo increment loading - its here
			this.initDisplay();
		}

		initSelectors() {
			this.$logoContainer = $('.brand-logos');
			this.$lmBtn = $('.logo__load-more');
			this.$logos = this.$logoContainer.find('li');
		}

		bindEvents() {
			if (this.$lmBtn.length && this.$logoContainer.length) {
				this.$lmBtn.on('click', (e) => this.handleLoadMore(e));
			}
		}

		initDisplay() {
			if (!this.$lmBtn.length || !this.$logoContainer.length) return;
			// Initial hide
			this.$logos.slice(this.visibleCount).css('display', 'none');
			// Initial check if button needed
			if (this.$logos.length <= this.visibleCount) {
				this.$lmBtn.css('display', 'none');
			}
		}

		handleLoadMore(e) {
			e.preventDefault();
			this.$logos.css('display', 'flex');
			this.$lmBtn.css('display', 'none');
		}
	}

	$(function () {
		new BrandLogos();
	});
})(jQuery);
